import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import { useGetFavoriteList } from "apps/CustomerPanel/Favorite/Pages/Ads/ServerSideStates";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const FavoriteCount = () => {
    const navigate = useNavigate()
    const favoriteList = useGetFavoriteList()
    const [count,setCount] = useState(0)
    useEffect(()=>{
        if(favoriteList?.data?.data)
        {
            let allList= favoriteList?.data?.data||[]
            let allLength = 0
            allList.forEach((item:any)=>{
                allLength+=item?.favorite?.length
            })
            setCount(allLength)
        }

    },[favoriteList?.data])
    return ( 
    <>
    <div
              onClick={() => {
                navigate(`/admin/panel?activePanelMenu=favorite`);
              }}
            >
                {
                    count?<>
                     <Badge>
                     <HeartFilled className="!text-xl hover:cursor-pointer !text-red-500 " />
                     </Badge>
                    </>:<>
                    
                    <HeartOutlined className="!text-xl hover:cursor-pointer " />
                    </>
                }
            </div>
    </> );
}
 
export default FavoriteCount;